module.exports = __webpack_public_path__ + "img/viewmarks.f6a10f84.svg";